module.exports = __webpack_public_path__ + "static/img/7-1.cbc8b98b.png";